module.exports = __webpack_public_path__ + "static/img/home_showmore_photo2@2x.2f70130.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/home_showmore_photo2@2x.png
// module id = yFQd
// module chunks = 0